export default {"src":"/_next/static/media/mck-logo-new.44ed7f2c.svg","height":23,"width":75,"blurWidth":0,"blurHeight":0};